import { useEffect, useState } from 'react'

/** One clock for a render tree, ticking slowly.
 *
 * ⚠️ A STAMP THAT NEVER MOVES IS THE BUG §6 IS ABOUT, ONE LEVEL DOWN. A tab left
 * open for three hours would keep saying "6 min ago" about a projection that is
 * now three hours old — a label that is wrong about how much to trust what is
 * under it, which is the whole reason the stamp exists. A minute is far finer
 * than the reconcile bound and costs one timer.
 *
 * P6-242b: THIS LIVED INSIDE `PortalHome.jsx` AND MOVED OUT BECAUSE THE FEED DID.
 * The feed's label (`AS OF HH:MM · N MIN AGO`) now lives in the sticky header,
 * which is a different render tree from the page under it, so it needs a clock
 * of its own and the two must not be two implementations of one tick. Both
 * import this. They are still two TIMERS — the header and the page are
 * separate trees — and that is the point: neither depends on the other being
 * mounted. */
export function useNow() {
  const [now, setNow] = useState(() => Date.now())
  useEffect(() => {
    const timer = setInterval(() => setNow(Date.now()), 60_000)
    return () => clearInterval(timer)
  }, [])
  return now
}
